import { creatUUid } from "../utils/index";
import { isIos } from "@/utils/lodash";
import { getDeviceInfo } from "@/utils/js_bridge_info";
import PresisiteAPIParams from "../persisits/lunch_params";

export const INS_APP_INFO = {
  cg_api_pigeon_session_id: creatUUid(),
  cg_api_app_id: "124024574287414",
  cg_api_app_version: "224.1.0.15.115",
  cg_api_app_build: "353721074",
  cg_api_x_bloks_version_id:
    "50dba3e3e4955d3cc1fe48fdf6ee3d237ec1848605c7ba6acd8ed6ce1f972886"
};

let userAgent = "";

export const USER_AGENT = () => {
  if (userAgent) {
    return userAgent;
  }
  const MACHINE =
    isIos() && getDeviceInfo().machine ? getDeviceInfo().machine : "iPhone11,2";
  const SYSTEM_VERSION =
    isIos() && getDeviceInfo().device && getDeviceInfo().device.system_version
      ? getDeviceInfo().device.system_version.replace(/\./g, "_")
      : "11_2";
  const SCALE =
    isIos() && getDeviceInfo().screen_scale
      ? getDeviceInfo().screen_scale.toFixed(2)
      : 2;
  const SYSTEM_VERSION_NAME =
    isIos() && getDeviceInfo().device.system_name
      ? getDeviceInfo().device.system_name
      : "iOS";

  const width = isIos() ? window.screen.width : 375;
  const height = isIos() ? window.screen.height : 667;

  userAgent = `Instagram ${
    INS_APP_INFO.cg_api_app_version
  } (${MACHINE};${SYSTEM_VERSION_NAME} ${SYSTEM_VERSION.replace(
    ".",
    "_"
  )};en_US;en-US;scale=${SCALE}; ${width * SCALE}x${height * SCALE};${
    INS_APP_INFO.cg_api_app_build
  }) AppleWebKit/420+`;
  return userAgent;
};

const acceptEncodeing = () => (isIos() ? "gzip, deflate" : "deflate");

export const IOS_HEADERS = async () => {
  const headers: any = {
    "User-Agent": USER_AGENT(),
    Accept: "*/*",
    "Accept-Language": "en-US;q=1.0",
    "Accept-Encoding": acceptEncodeing(),
    "X-IG-Connection-Type": "WiFi",
    "X-Bloks-Version-Id": INS_APP_INFO.cg_api_x_bloks_version_id,
    "X-Bloks-Is-Panorama-Enabled": "true",
    "X-IG-App-Locale": "en",
    "X-IG-App-Startup-Country": "unknown",
    "X-IG-Capabilities": "36r/F38=",
    "X-IG-App-ID": INS_APP_INFO.cg_api_app_id,
    "X-IG-ABR-Connection-Speed-KBPS": "0",
    "X-IG-Device-ID": await PresisiteAPIParams.getAPIId("cg_api_device_id"),
    "X-IG-Family-Device-ID": await PresisiteAPIParams.getAPIId(
      "cg_api_family_device_id"
    ),
    "X-IG-Mapped-Locale": "en_US",
    "X-IG-Timezone-Offset": String(getDeviceInfo().timezone || 28800),
    "X-IG-Connection-Speed": "-1kbps",
    "X-IG-Bandwidth-Speed-KBPS": "0.000",
    "X-IG-Device-Locale": "en-US",
    "X-Pigeon-Session-Id": INS_APP_INFO.cg_api_pigeon_session_id,
    "X-Pigeon-Rawclienttime": "" + new Date().getTime() / 1000,
    "cache-control": "no-cache"
  };
  const xMid = await PresisiteAPIParams.getMid();
  if (xMid) {
    headers["X-MID"] = xMid;
  }
  return headers;
};

export const cg_api_lib_version = "1858.112000";

export const cg_api_random_sim = (() => {
  let string = "0.9";
  for (let i = 0; i < 16; i++) {
    string += Math.floor(Math.random() * 10);
  }
  return string;
})();

// export const  cg_api_colorspace: string =   UIScreen.main.traitCollection.displayGamut == .P3 ?
// "kCGColorSpaceDisplayP3" : "kCGColorSpaceDeviceRGB"
export const cg_api_colorspace: string = "kCGColorSpaceDeviceRGB";
